/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiPersonFullSitterProfileRetrieveFrequency =
  (typeof ApiPersonFullSitterProfileRetrieveFrequency)[keyof typeof ApiPersonFullSitterProfileRetrieveFrequency];

export const ApiPersonFullSitterProfileRetrieveFrequency = {
  onetime: 'onetime',
  repeat: 'repeat',
} as const;
